<template>
	<div>
        <br/>
		<label for="action">Action</label>

        <select id="action" class="form-control" v-model="action">
            <option v-for="action in actions" :key="action.id" :value="action.id">
                {{ action.action }}
            </option>
        </select>
	</div>
</template>

<script>
	export default {
		data() {
			return {
                action: null,
				actions: [
                    {
                        id: 1,
                        action: 'action 1'
                    },
                    {
                        id: 2,
                        action: 'action 2'
                    },
                    {
                        id: 3,
                        action: 'action 3'
                    }
                ]
			}
		}
	}
</script>
